import { AutocompleteStore } from '@searchspring/snap-store-mobx'
import { UrlManager, UrlTranslator } from '@searchspring/snap-url-manager';

const autocompleteConfig = {
    id: 'autocomplete',
    selector: '#searchInput',
    settings: {
        syncInputs: true
    },
};

const autocompleteUrlManager = new UrlManager(new UrlTranslator()).detach();
const store = new AutocompleteStore(autocompleteConfig, { urlManager: autocompleteUrlManager });

store.update(data);

console.log(store.toJSON());
